import React from "react";
import { Button } from "@/components/ui/buttons/button";

export const TelegramGuard: React.FC = () => {
  const handleOpenTelegram = () => {
    window.open("https://t.me/pokelands_bot", "_blank");
  };

  return (
    <main
      className="mx-auto my-auto fixed inset-0 z-[100] flex flex-col items-center justify-center bg-pk-night-1"
      style={{
        height: "min(100svh, calc(480px * 18 / 9))",
        maxWidth: "480px",
      }}
    >
      <div className="relative z-10 flex flex-col items-center gap-8 w-full max-w-xs px-6 text-center">
        {/* Logo */}
        <div className="relative w-[280px] xs:w-[340px] h-auto mb-4">
          <div className="absolute inset-0 bg-pk-purple-3 blur-2xl opacity-20 rounded-full" />
          <img
            src="/assets/app-ui/logo.png"
            alt="Logo"
            className="relative z-10 w-full h-full object-contain filter drop-shadow-[0_0_15px_rgba(122,122,122,0.25)]"
          />
        </div>

        <div className="flex flex-col gap-4">
          <h2 className="text-xl font-black text-white tracking-tight uppercase italic drop-shadow-md">
            Telegram Required
          </h2>
          <p className="text-pk-gray-3 text-sm font-bold leading-relaxed">
            Hey! In order to play the game, you need to open the app from inside
            Telegram.
          </p>
        </div>

        <Button variant="purple" onClick={handleOpenTelegram}>
          <div className="px-6 py-1 flex flex-col items-center">
            <span className="text-white text-lg font-black tracking-wider uppercase italic drop-shadow-sm">
              Open in Telegram
            </span>
          </div>
        </Button>
      </div>
    </main>
  );
};
